import { z } from 'zod/v4';

import { configurationSettingSchema } from './configuration-setting.schema';

export const configurationSettingsListSchema = z.object({
  configurationSettings: z.array(configurationSettingSchema),
  settingsSourcedFromParentAccount: z.boolean(),
});

export type ConfigurationSettingsList = z.infer<
  typeof configurationSettingsListSchema
>;
